import { useEffect, useMemo, useState } from "react";
import { INavigationMenuItem } from "../types/NavigationMenu";
import { dmnIdentity } from "../utils/dmnIdentity";
import {
  getEnvironmentProps,
  GetEnvironmentPropsResponse
} from "../utils/environment";
import { getFilterNavigationItems } from "../utils/navigation/filterNavigationItems";
import usePermissions from "./usePermissions";
import { useUserContext } from "./useUserContext";

const useNavBarItems = () => {
  const [environmentProps, setEnvironmentProps] =
    useState<GetEnvironmentPropsResponse>();
  const permissions = usePermissions();
  const userContext = useUserContext();
  const loading = !environmentProps || permissions.loading;

  useEffect(() => {
    (async () => {
      const token = await dmnIdentity.getAccessToken();
      setEnvironmentProps(getEnvironmentProps(token));
    })();
  }, []);

  const filteredItems = useMemo(
    () => getFilterNavigationItems(permissions, environmentProps, userContext),
    [permissions, environmentProps]
  );

  const { topItems, bottomItems } = useMemo(() => {
    return filteredItems.reduce(
      (acc, item) => {
        if (item.bottom) {
          acc.bottomItems.push(item);
        } else {
          acc.topItems.push(item);
        }
        return acc;
      },
      {
        topItems: [] as INavigationMenuItem[],
        bottomItems: [] as INavigationMenuItem[]
      }
    );
  }, [filteredItems]);

  const appBaseUrl = environmentProps?.APP_BASE_URL ?? "";

  const response = useMemo(
    () => ({
      items: filteredItems,
      filteredItems,
      topItems,
      bottomItems,
      loading,
      appBaseUrl
    }),
    [filteredItems, topItems, bottomItems, loading, appBaseUrl]
  );

  return response;
};

export default useNavBarItems;
